import React from 'react';
import '../../App.css';
import '../glance/glanceWrapp.css';

function GlanceWrapp({ data }) {
    if (!data) return null; // Safety check

    const summaries = data.class_action_summaries || []; // Get class action summaries

    return (
        <section className="glance-wrapp" id="glance-wrapp">
            <div className="container">
                {/* Main heading and description */}
                {data?.aboutcon3 && <div dangerouslySetInnerHTML={{ __html: data.aboutcon3 }} />}

                <div className="row glance-row">
                    <div className="col-md-7">
                        <div className="panel-left">
                            <table className="mini-table">
                                <tbody>
                                    {summaries.map((summary) => (
                                        <React.Fragment key={summary.id}>
                                            <tr>
                                                <th>Defendant</th>
                                                <td dangerouslySetInnerHTML={{__html:summary.defendant}}></td>
                                            </tr>
                                            <tr>
                                                <th>Allegations</th>
                                                <td>{summary.allegations}</td>
                                            </tr>
                                            <tr>
                                                <th>Group Members</th>
                                                <td>{summary.group_members}</td>
                                            </tr>
                                            <tr>
                                                <th>Relief Sought</th>
                                                <td>{summary.relief_sought}</td>
                                            </tr>
                                            <tr>
                                                <th>Court</th>
                                                <td>{summary.court}</td>
                                            </tr>
                                            <tr>
                                                <th>Status</th>
                                                <td dangerouslySetInnerHTML={{__html:summary.status}}></td>
                                                 
                                            </tr>
                                        </React.Fragment>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div className="col-md-5">
                        <div className="panel-right">
                            {/* Registration steps */}
                            {data?.steptitle1 && <div dangerouslySetInnerHTML={{ __html: data.steptitle1 }} />}
                            <a href="/registerpage">
                                <button className="gln-btn">Register Now (Free)</button>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default GlanceWrapp;
